import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";

function Home() {
	const navigate = useNavigate();
	const { state } = useLocation();
	const clickHandler = () => {
		navigate("/login");
	};
	const [isLoaded, setIsLoaded] = useState(false);

	const username = state !== null ? state.username : "";

	useEffect(() => {
		if (username === "") {
			navigate("/login");
		}
		setTimeout(() => {
			setIsLoaded(true);
		}, 1000);
	}, [navigate, username]);

	return (
		<div>
			{isLoaded ? (
				<>
					<div>Welcome home {username}</div>
					<div style={{ position: "relative", textAlign: "right" }}>
						<Button variant="primary" size="sm" active onClick={clickHandler}>
							Logout
						</Button>
					</div>
				</>
			) : (
				<Spinner animation="border" />
			)}
		</div>
	);
}

export default Home;
